import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePageView from '../views/HomePageView.vue';
import MenuPageView from '../views/MenuPageView.vue';
import FullScreenMenu from '../components/FullScreenMenu.vue'; // 导入你的 FullScreenMenu 组件
import OrderPageView from '../views/OrderPageView.vue';
import ReservationPageView from '../views/ReservationPageView.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePageView,
  },
  {
    path: '/menu',
    name: 'Menu',
    component: MenuPageView,
  },
  {
    path: '/full-screen-menu', // 添加 FullScreenMenu 的路由
    name: 'FullScreenMenu',
    component: FullScreenMenu,
  },
  {
    path: '/order',
    name: 'Order',
    component: OrderPageView,
  },
  {
    path: '/reserve',
    name: 'Reserve',
    component: ReservationPageView,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;